import { FC, useMemo, useState, useEffect } from 'react';
import { RsPriceRadio } from 'components/Rsuite/Radio';
import { BudgetType, ActionType } from 'core/rtbCampaign/singlePage/common';
import { numberWithCommas } from 'utils/StringUtil';

type BudgetPrices = Record<BudgetType, string>;

interface BudgetChoiceProps {
  budgetType: BudgetType;
  onBudgetTypeChange: (v: BudgetType) => void;
  budget: string;
  dailyTargetBudget: string;
  onBudgetChange: (v: BudgetPrices) => void;
  dailyErrorMessage: string | undefined;
  totalErrorMessage: string | undefined;
  className?: string;
  actionType: ActionType;
  disabled: boolean;
}

export const BudgetChoice: FC<BudgetChoiceProps> = ({
  budgetType,
  onBudgetTypeChange,
  budget,
  dailyTargetBudget,
  onBudgetChange,
  className = '',
  dailyErrorMessage,
  totalErrorMessage,
  actionType,
  disabled,
}) => {
  const isEditMode = disabled && actionType === ActionType.EDIT;
  const data = useMemo(() => {
    const suggestedTotalBudget = () => (
      <span>預算消耗速度依競爭情況浮動，可能於走期結束前消耗完畢</span>
    );

    const budgetData = {
      [BudgetType.DAILY]: {
        value: BudgetType.DAILY,
        label: '設定每日預算',
        disabled: isEditMode,
        hint: (
          <span>
            您設定的總預算預估為 {numberWithCommas(Number(budget).toFixed(2))}
          </span>
        ),
        errorMessage: dailyErrorMessage
          ? dailyErrorMessage
          : totalErrorMessage
            ? totalErrorMessage
            : undefined,
      },
      [BudgetType.TOTAL]: {
        value: BudgetType.TOTAL,
        label: '設定活動總預算',
        disabled: isEditMode,
        hint: suggestedTotalBudget(),
        errorMessage: totalErrorMessage,
      },
    };

    const budgetTypes = [BudgetType.DAILY, BudgetType.TOTAL];

    return budgetTypes.map((budgetType) => budgetData[budgetType]);
  }, [dailyErrorMessage, totalErrorMessage, budget]);

  const budgets = {
    [BudgetType.DAILY]: dailyTargetBudget,
    [BudgetType.TOTAL]: budget,
  };

  const handleBudgetTypeChange = (newBudgetType) => {
    onBudgetTypeChange(newBudgetType);
  };
  const handleBudgetChange = (newBudgets) => {
    onBudgetChange(newBudgets);
  };

  return (
    <RsPriceRadio
      data={data}
      selected={budgetType}
      onChange={handleBudgetTypeChange}
      prices={budgets}
      onPriceChange={handleBudgetChange}
      className={className}
    />
  );
};
